"use strict";
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */
Object.defineProperty(exports, "__esModule", { value: true });
// Email domains that we are not going to validate.
// This is maintained at
// https://github.com/mailcheck/mailcheck/wiki/List-of-Popular-Domains (aside
// from the MOZ section)
// Mailcheck.defaultDomains is much shorter than this list.
const TopEmailDomains = new Set([
    '126.com',
    '163.com',
    '21cn.com',
    'abv.bg',
    'alice.it',
    'aliyun.com',
    'aol.com',
    'aol.it',
    'arcor.de',
    'arnet.com.ar',
    'att.net',
    'bell.net',
    'bellsouth.net',
    'bigpond.com',
    'bk.ru',
    'bluewin.ch',
    'blueyonder.co.uk',
    'bol.com.br',
    'bt.com',
    'btinternet.com',
    'charter.net',
    'comcast.net',
    'cox.net',
    'daum.net',
    'earthlink.net',
    'email.com',
    'email.it',
    'facebook.com',
    'fastmail.fm',
    'fibertel.com.ar',
    'foxmail.com',
    'free.fr',
    'freemail.hu',
    'freenet.de',
    'freeserve.co.uk',
    'games.com',
    'globo.com',
    'globomail.com',
    'gmai.com',
    'gmail.com',
    'gmil.com',
    'gmx.at',
    'gmx.com',
    'gmx.de',
    'gmx.fr',
    'gmx.net',
    'google.com',
    'googlemail.com',
    'hanmail.net',
    'hotmail.be',
    'hotmail.ca',
    'hotmail.co.uk',
    'hotmail.com.ar',
    'hotmail.com.br',
    'hotmail.com.mx',
    'hotmail.com',
    'hotmail.de',
    'hotmail.es',
    'hotmail.fr',
    'hotmail.it',
    'hush.com',
    'hushmail.com',
    'icloud.com',
    'ig.com.br',
    'iname.com',
    'inbox.com',
    'inbox.ru',
    'interia.pl',
    'itelefonica.com.br',
    'juno.com',
    'keemail.me',
    'laposte.net',
    'lavabit.com',
    'libero.it',
    'list.ru',
    'live.be',
    'live.co.uk',
    'live.com.ar',
    'live.com.mx',
    'live.com',
    'live.de',
    'live.fr',
    'live.it',
    'live.nl',
    'love.com',
    'mac.com',
    'mail.com',
    'mail.ru',
    'me.com',
    'mozilla.com',
    'msn.com',
    'nate.com',
    'naver.com',
    'neuf.fr',
    'ntlworld.com',
    'o2.co.uk',
    'o2.pl',
    'oi.com.br',
    'online.de',
    'op.pl',
    'orange.fr',
    'orange.net',
    'outlook.com.br',
    'outlook.com',
    'outlook.de',
    'outlook.es',
    'outlook.fr',
    'pobox.com',
    'poste.it',
    'prodigy.net.mx',
    'protonmail.ch',
    'protonmail.com',
    'qq.com',
    'r7.com',
    'rambler.ru',
    'rediffmail.com',
    'restmail.net',
    'rocketmail.com',
    'rogers.com',
    'safe-mail.net',
    'sbcglobal.net',
    'seznam.cz',
    'sfr.fr',
    'shaw.ca',
    'sina.cn',
    'sina.com',
    'sky.com',
    'skynet.be',
    'speedy.com.ar',
    'sympatico.ca',
    't-online.de',
    'talktalk.co.uk',
    'telenet.be',
    'teletu.it',
    'terra.com.br',
    'tin.it',
    'tiscali.co.uk',
    'tiscali.it',
    'tuta.io',
    'tutamail.com',
    'tutanota.com',
    'tutanota.de',
    'tvcablenet.be',
    'ukr.net',
    'uol.com.br',
    'verizon.net',
    'virgilio.it',
    'virgin.net',
    'virginmedia.com',
    'voo.be',
    'wanadoo.co.uk',
    'wanadoo.fr',
    'web.de',
    'wow.com',
    'wp.pl',
    'ya.ru',
    'yahoo.ca',
    'yahoo.co.id',
    'yahoo.co.in',
    'yahoo.co.jp',
    'yahoo.co.kr',
    'yahoo.co.uk',
    'yahoo.com.ar',
    'yahoo.com.au',
    'yahoo.com.br',
    'yahoo.com.mx',
    'yahoo.com.ph',
    'yahoo.com.sg',
    'yahoo.com.tw',
    'yahoo.com',
    'yahoo.de',
    'yahoo.es',
    'yahoo.fr',
    'yahoo.gr',
    'yahoo.it',
    'yandex.com',
    'yandex.ru',
    'yeah.net',
    'ygm.com',
    'ymail.com',
    'zipmail.com.br',
    'zoho.com',
]);
exports.default = TopEmailDomains;
//# sourceMappingURL=data:application/json;base64,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